import * as Sentry from '@sentry/react';
import {isReloadingForStaleChunk} from '../lib/preloadErrorRecovery';

let isInitialized = false;

/**
 * Sentry `beforeSend`. YOJO-3428 [an open care-portal tab breaks on the next click after every
 * deploy]: while the page is reloading for a stale chunk, the render error React.lazy throws
 * before the reload lands is not a real failure, so it is dropped.
 */
export const dropEventsWhileReloadingForStaleChunk = <T>(event: T): T | null =>
  isReloadingForStaleChunk() ? null : event;

export const initSentry = () => {
  if (isInitialized) {
    console.debug('[Sentry] Already initialized, skipping...');
    return;
  }

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  
  if (!dsn) {
    console.warn('[Sentry] DSN not configured');
    return;
  }

  try {
    Sentry.init({
      dsn,
      beforeSend: dropEventsWhileReloadingForStaleChunk,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration()
      ],
      // Tracing
      tracesSampleRate: 1.0,
      tracePropagationTargets: [
        'localhost',
        /^https:\/\/yourserver\.io\/api/
      ],
      // Session Replay
      replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
      replaysOnErrorSampleRate: 1.0
    });
    
    isInitialized = true;
    console.debug('[Sentry] Initialized successfully');
  } catch (error) {
    console.error('[Sentry] Initialization failed:', error);
  }
};
